<template>
<li class="search-placeholder">
  <i class="material-icons left" v-show="!searchLoader">search</i>
  <i class="material-icons left fa-spin" v-show="searchLoader">autorenew</i>
  <input id="input_search" type="text" v-bind:placeholder="$t('views.navbar.searchobjects')" v-model="search">
  <div class="search-results z-depth-1" v-if="search.length > 0">
    <table class="striped highlight">
        <tbody>
        <tr class="clickable" v-for="searchResult in searchResults.slice(0, 5)" v-bind:key="searchResult.railObjectId" v-on:click="showDetail(searchResult.railObject)">
            <td class="alarm-list-type">{{searchResult.railObject.DataSourceCode.substring(0, 2)}}</td>
            <td class="alarm-list-switch">
              <div>
                {{searchResult.regionName}} \ {{searchResult.departmentName}} \ {{searchResult.complexName}} \ <span class="alarm-list-railobject">{{searchResult.railObjectName}}</span>
              </div>
              <div v-if="searchResult.railObjectChildrenFound.length > 0" class="alarm-list-child">
                {{ searchResult.railObjectChildrenFound.join('&nbsp;&nbsp;|&nbsp;&nbsp;') }}
              </div>
            </td>
            <td class="alarm-list-status" v-if="searchResult.railObject.MonitorStatusId === 2"><i class="warning-text material-icons left">error</i></td>
            <td class="alarm-list-status" v-if="searchResult.railObject.MonitorStatusId === 3"><i class="alarm-text material-icons left">warning</i></td>
            <td class="alarm-list-status" v-if="searchResult.railObject.MonitorStatusId !== 2 && searchResult.railObject.MonitorStatusId !== 3">&nbsp;</td>
        </tr>

        <tr class="clickable">
            <td colspan="4" class="search-list-button">
              <div class="row-button" @click="gotoSearch()">
                <i class="material-icons">search</i>
                {{ $t('views.navbar.openallsearchresults') }}
              </div>
            </td>
        </tr>
        </tbody>
    </table>
  </div>
</li>
</template>

<script>
// import UtilitiesService from '../../services/UtilitiesService'
import RailObjectService from '../../services/RailObjectService'
import DepartmentService from '../../services/DepartmentService'
import RegionService from '../../services/RegionService'
import ComplexService from '../../services/ComplexService'
import Router from '../../router/index'

var searchTimer = null

export default {
  name: 'SearchBar',
  props: ['railObjects'],
  data () {
    return {
      numberInError: 0,
      numberInWarning: 0,
      numberInMaintenance: 0,
      search: '',
      searchResults: [],
      searchLoader: false,
      searchSet: []
    }
  },
  created: function () {
  },
  mounted: function () {
    this.$root.$el.addEventListener('click', this.rootClick)

    this.$worker.run((regions, departments, complexes, railObjects, railObjectChildren) => {
      var searchSet = []
      var regionsById = {}
      var departmentsById = {}
      var complexesById = {}
      regions.forEach((region) => {
        regionsById[region.RegionId] = region
      })
      departments.forEach((department) => {
        departmentsById[department.DepartmentId] = department
      })
      complexes.forEach((complex) => {
        complexesById[complex.ComplexId] = complex
      })

      railObjects.forEach(railObject => {
        let region = regionsById[railObject.RegionId] // This should be RegionId with a capital R. This hasn't worked since May 2018 (#015da74), so we keep the 'bug' and don't show the region, Update: Leon 2023-07-07, fixed. Customer request
        let department = departmentsById[railObject.DepartmentId]
        let complex = complexesById[railObject.ComplexId]
        const children = railObjectChildren.filter(c => c.ParentRailObjectId === railObject.RailObjectId)
          .map(c =>
            ({
              name: c.Name,
              railObjectId: c.RailObjectId,
              uniqueId: c.UniqueId
            }))

        searchSet.push({
          regionName: region ? region.Name : '',
          departmentName: department ? department.Name : '',
          complexName: complex ? complex.Name : '',
          railObjectName: railObject.Name,
          railObjectChildren: children,
          railObjectChildrenFound: [],
          railObject: railObject,
          railObjectId: railObject.RailObjectId
        })
      })
      return searchSet
    }, [RegionService.getRegions(), DepartmentService.getDepartments(), ComplexService.getComplexes(), RailObjectService.getRailObjects(), RailObjectService.getRailObjectChildren()])
      .then((result) => {
        this.searchSet = result
      })
  },
  methods: {
    showDetail: function (railObject) {
      this.search = ''
      setTimeout(() => {
        if (railObject.DataSourceCode === 'WID') {
          Router.push({
            name: 'Switch',
            params: {
              id: railObject.RailObjectId,
              measurementId: railObject.LastMeasurementId
            },
            props: true
          })
        }
        if (railObject.DataSourceCode === 'ATD') {
          Router.push({
            name: 'AxleCounter',
            params: {
              railobjectid: railObject.RailObjectId
            // passedMeasurementId: railObject.LastMeasurementId
            }
          })
        }
        if (railObject.DataSourceCode === 'AKD') {
          Router.push({
            name: 'AxleShunt',
            params: {
              id: railObject.RailObjectId
            }
          })
        }
        if (railObject.DataSourceCode === 'CDD') {
          Router.push({
            name: 'MixedSignals',
            params: {
              railobjectid: railObject.RailObjectId,
              railObject: railObject
            },
            props: true
          })
        }
      })
    },
    rootClick: function () {
      this.search = ''
    },
    gotoSearch: function () {
      Router.push({
        name: 'Search',
        query: {
          text: this.search
        },
        props: true
      })
    }
  },
  watch: {
    'search': {
      handler: function (val, oldVal) {
        var find = (searchItems, search) => {
          let priorityIndexDict = []
          let value = ''

          // Initialize value and priorityIndexDict
          let searchIndex = 0
          searchItems.forEach((searchString, i) => {
            priorityIndexDict.push({priority: i, index: searchIndex})
            searchIndex += String(searchString).length + 1
            value += searchString + ' '
          })

          // Complete match gets the highest priority
          if (search.includes(' ') && value.includes(search)) {
            return 4
          }

          // Try to find all search values
          let priorityIndex = value.length
          value = value.toLowerCase() // .trim()
          let searchArray = search.split(' ')
          for (let i = 0; i < searchArray.length; i++) {
            let index = value.indexOf(searchArray[i].toLowerCase())
            if (index === -1) {
              return -1 // Value not found
            }
            if (index < priorityIndex) {
              priorityIndex = index
            }
          }

          const priority = priorityIndexDict.filter(p => p.index <= priorityIndex).map(p => p.priority)
          return priority
        }

        if (val === '') {
          this.searchResults = []
          return
        }
        this.searchLoader = true
        clearTimeout(searchTimer)
        searchTimer = setTimeout(() => {
          this.searchResults = []
          const prioritySearchResults = []
          this.searchSet.forEach(searchItem => {
            searchItem.railObjectChildrenFound = []
            const priority = find([searchItem.regionName, searchItem.departmentName, searchItem.complexName, searchItem.railObjectName], val)
            if (priority !== -1) { // Search value found
              prioritySearchResults.push(({object: searchItem, priority: priority}))
            } else if (searchItem.railObjectId.toString() === val || searchItem.railObject.UniqueId === val) { // Search value is railObjectId
              prioritySearchResults.push(({object: searchItem, priority: -1})) // Lowest priority
            } else { // Search for children that match search value
              searchItem.railObjectChildren.forEach(child => {
                if (find([child.name], val) !== -1 || child.railObjectId.toString() === val || child.uniqueId === val) {
                  searchItem.railObjectChildrenFound.push(child.name)
                }
              })
              if (searchItem.railObjectChildrenFound.length > 0) {
                prioritySearchResults.push(({object: searchItem, priority: 2.5})) // Priority between complexName and railObjectName
              }
            }
          })

          prioritySearchResults.sort((first, second) => {
            const priorityOrder = second.priority - first.priority
            if (priorityOrder !== 0) {
              return priorityOrder
            }
            return first.object.railObjectName.localeCompare(second.object.railObjectName)
          })
          this.searchResults = prioritySearchResults.map(x => x.object)
          this.searchLoader = false
        }, 100)
      }
    }
  },
  beforeDestroy: function () {
    this.$root.$el.removeEventListener('click', this.rootClick)
  }
}
</script>

<style>
.search-placeholder {
  height: 44px;
  width: 344px;
  margin-top: 7px;
  margin-bottom: 7px;
  background-color: #fff;
  position: relative;
  padding-left: 10px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.search-placeholder input {
  width: 280px !important;
  position: absolute;
  height: 44px !important;
  margin: 0px !important;
  border-bottom: none !important;
}

.nav-poss .nav-wrapper .search-placeholder i {
  height: 44px;
  line-height: 44px;
  color: rgba(0, 0, 0, 0.54);
}

.search-results {
  width: 624px;
  background-color: #fff;
  z-index: 1000;
  position: absolute;
  line-height: initial;
  color: #000;
  left: 0px;
  top: 44px;
}

#input_search {
  border-bottom: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.search-list-button {
  text-align: center;
}

.alarm-list-type,
.alarm-list-railobject {
  font-weight: 700;
}

.alarm-list-type,
.alarm-list-status,
.alarm-list-switch {
  vertical-align: top;
}

.alarm-list-child {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/nav/_SearchBar.vue